jQuery($ => {
    class PricingModal {
      constructor(element) {
        this._              = element;
        this._element       = $(element);
        this._tabsContainer = this._element.find('.o-pricing-modal__tabs');
        this._tabs          = this._element.find('.o-pricing-modal__tab input');
        this._tables        = this._element.find('.o-pricing-modal__table');
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._tabs.on('change', (e) => this.transitionTables(e.currentTarget));
      }

      handleOpen = (slug) => {
        if (slug) {          
          this.transitionTables(null, slug, 0);
          this._tabs.filter(':checked').prop('checked', false);
          this._tabs.filter(`[value="${slug}"]`).prop('checked', true);
        }

        this._element.modal('handleOpen');
      }

      displayTable = (slug, speed) => {
        if (speed === undefined) speed = 250;
        const nextTable = this._tables.filter(`#pricing-table-${slug}`);
        nextTable.fadeIn(speed, () => {
          nextTable.addClass('o-pricing-modal__table--active');
        });
      }

      transitionTables = (target, slug, speed) => {
        if (speed === undefined) speed = 250;

        if (!target && slug) {
          target = this._tabs.filter(`[value="${slug}"]`)[0];

          if (!target) {
            return;
          }
        }
        this._element.find('.o-pricing-modal__tab--active').removeClass('o-pricing-modal__tab--active');
        $(target).parent().addClass('o-pricing-modal__tab--active');

        // Slide tabs to make sure the active tab is visible (mobile)
        if (this._tabsContainer[0] && $(target).parent()[0]) {
          this._tabsContainer[0].scrollTo({ left: $(target).parent()[0].getBoundingClientRect().left, behavior: 'smooth' });
        }

        const activeTable = this._tables.filter('.o-pricing-modal__table--active');
        if (activeTable) {
          activeTable.fadeOut(speed, () => {
            activeTable.removeClass('o-pricing-modal__table--active');
            this.displayTable(target.value);
          });
        } else {
          this.displayTable(target.value);
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.pricing_modal = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].pricing_modal = new PricingModal(_[i], opt);
        else
          ret = _[i].pricing_modal[opt].apply(_[i].pricing_modal, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-pricing-modal').pricing_modal();
});